export default "__VITE_ASSET__bb53783f__"